import { css } from 'styled-components';
import token from 'styled-token';
import { buttonResetMixin } from '../buttonResetMixin';
import { focusMixin } from '../focusMixin';
import { hoverMediaQueryMixin } from '../hoverMediaQueryMixin';
import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
import { spacingMixin } from '../spacingMixin';
var buttonCSS = function buttonCSS(props) {
  if (props.as !== 'button') {
    return '';
  }
  return buttonResetMixin(props);
};
var defaultColorCSS = function defaultColorCSS(props) {
  return token({
    defaultColor: 'Anchor.defaultColor',
    focusColor: 'Anchor.focusColor',
    visitedColor: 'Anchor.visitedColor',
    hoverColor: 'Anchor.hoverColor',
    activeColor: 'Anchor.activeColor'
  }, function (_ref) {
    var defaultColor = _ref.defaultColor,
      focusColor = _ref.focusColor,
      visitedColor = _ref.visitedColor,
      hoverColor = _ref.hoverColor,
      activeColor = _ref.activeColor;
    return css(["&{color:", ";}&:focus{color:", ";}&:visited{color:", ";}&:not(:active){", ";}&:active{color:", ";}"], defaultColor, focusColor, visitedColor, hoverMediaQueryMixin("color: " + hoverColor + ";"), activeColor);
  })(props);
};
var inverseColorCSS = function inverseColorCSS(props) {
  return token({
    inverseColor: 'Anchor.inverseColor',
    inverseHoverColor: 'Anchor.inverseHoverColor',
    inverseActiveColor: 'Anchor.inverseActiveColor',
    inverseVisitedColor: 'Anchor.inverseVisitedColor'
  }, function (_ref2) {
    var inverseColor = _ref2.inverseColor,
      inverseHoverColor = _ref2.inverseHoverColor,
      inverseActiveColor = _ref2.inverseActiveColor,
      inverseVisitedColor = _ref2.inverseVisitedColor;
    return css(["&{color:", ";}&:active{color:", ";}&:not(:active){", ";}&:active{text-decoration:none;}&:visited{color:", ";}"], inverseColor, inverseActiveColor, hoverMediaQueryMixin("color: " + inverseHoverColor + "; text-decoration: none;"), inverseVisitedColor);
  })(props);
};
var inverseCSS = function inverseCSS(props) {
  return props.inverse ? inverseColorCSS(props) : defaultColorCSS(props);
};

/** @class AnchorMixin */
/** @method */
export var AnchorMixin = function AnchorMixin(props) {
  return token('Anchor.textDecoration', function (textDecoration) {
    return css(["cursor:pointer;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;text-decoration:", ";", " ", " ", " ", ""], textDecoration || 'underline', focusMixin(props), inlineMediaQueryMixin('inverse', inverseCSS)(props), buttonCSS(props), spacingMixin(props));
  })(props);
};